import { ButtonLink } from '@backstage/ui';
import { MarkdownContent } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import { EntityInfoCard, useEntity } from '@backstage/plugin-catalog-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';
import { usePermission } from '@backstage/plugin-permission-react';
import { taskCreatePermission } from '@backstage/plugin-scaffolder-common/alpha';

export const TemplateDescriptionCard = () => {
  const { entity } = useEntity();
  const templateRoute = useRouteRef(scaffolderPlugin.routes.selectedTemplate);
  const { allowed: canCreateTask } = usePermission({
    permission: taskCreatePermission,
  });

  const launchHref = templateRoute({
    templateName: entity.metadata.name,
    namespace: entity.metadata.namespace || DEFAULT_NAMESPACE,
  });
  const showLaunchButton = canCreateTask && launchHref;
  const description = entity.metadata.description;

  const actions = showLaunchButton ? (
    <ButtonLink href={launchHref} variant="primary" children="LAUNCH" />
  ) : undefined;

  return (
    <EntityInfoCard
      title="Description"
      children={description && <MarkdownContent content={description} />}
      footerActions={actions}
    />
  );
};
